<!--库存采购单操作记录-->
<template>
    <el-dialog :title="msg('库存采购单操作记录')" :close-on-click-modal="false" 
        :visible.sync="visible" width="45%"
        :fullscreen="isMinScreen"
    >
        <div v-if="data" class="ctrl-panel">
            <h3>库存采购单变化详情</h3>
            <div>{{ purchaseCode?  "采购单号： " + purchaseCode:''  }}</div>
            <div style="padding-top:6px;padding-bottom:10px;">{{ expCode?  "快递单号： " + expCode:''  }}</div>
            <div class="trace-wrap" style="margin-left:-35px;">
                <div class="trace-box">
                    <el-timeline >
                        <el-timeline-item
                            type="danger"
                            v-for="(item, index) in data" :key="index"
                            :timestamp="item.created">
                                {{item.createrName}} : {{item.ctrl}} - {{item.label}}-{{item.remark}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
    </el-dialog>
    </template>
    
    <script>
    export default {
        name: 'StockTrace',
        comments: {
    
        },
        mounted: function(){
    
        },
        data(){
            return{
                id: null,
                data: null,
                expCode: null,
                purchaseCode: null,
                visible: false
            }
        },
        computed: {
            isMinScreen: {  //是否小屏幕，浏览器
                get() {
                    var is = this.$store.state.isMinScreen;
                    return is;
                }
            },
        },
        methods: {
            showTracks(id, purchaseCode, expCode){
                this.purchaseCode = purchaseCode;
                this.expCode = expCode;
                this.visible=true;
                this.id = id;
                this.data = null;
                this.$axios.post(this.$kit.api.inventoryIn.traces+"?id="+id)
                    .then((result) => {
                        if(result.status){
                            this.data = result.data;
                        }else{
                            this.$message(result.msg || this.msg('获取失败'));
                        }
                    });
            }
        }
    }
    </script>
    
    <style lang="scss" scoped>
    .trace-wrap{display:flex; justify-content: space-between;}
    .trace-box{padding: 10px;}
    .detail{margin:10px;}
    .detail a{display:inline-block; margin-left: 8px;}
    </style>